module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/applicant/khbnotificationltr/khbnotificationltr.component.css
// module id = ./src/app/applicant/khbnotificationltr/khbnotificationltr.component.css
// module chunks = main